var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((_vm.honorList),function(item,index){return _c('div',{key:index,staticClass:"honor"},[_c('el-image',{staticClass:"honorImg",attrs:{"fit":"contain","src":item,"preview-src-list":_vm.honorList}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }